import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";

const firehoseSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.stream,
  connectionName: "Firehose-SSE",
});

export default firehoseSSEClient;
